import React from 'react';
import { motion } from 'framer-motion';
import { PartnrMark } from '@/components/partnr/kit/PartnrMark';
import { GlassCard } from '../GlassCard';
import { GlassCTA } from '../GlassCTA';

interface WelcomeStepProps {
  onNext: () => void;
}

export function WelcomeStep({ onNext }: WelcomeStepProps) {
  return (
    <GlassCard>
      <div className="flex flex-col items-center text-center">
        {/* Partnr icon with entrance animation */}
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="mb-8 flex h-14 w-14 items-center justify-center rounded-full border border-line bg-paper-sunken text-ink"
        >
          <PartnrMark size={28} state="done" />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.3 }}
          className="font-display text-[28px] font-semibold leading-relaxed text-ink tracking-tight"
        >
          Hi, I'm Partnr. I work behind the scenes to keep your thinking
          organized so you don't have to.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.5 }}
          className="mt-5 text-base leading-relaxed"
          style={{ color: 'hsl(var(--ink-2))' }}
        >
          Every mind works differently. Let me learn how yours does.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.7 }}
          className="mt-10"
        >
          <GlassCTA onClick={onNext}>Let's go</GlassCTA>
        </motion.div>
      </div>
    </GlassCard>
  );
}
